// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__O3VyG","col":"styles_col__61YY4"};